// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

import HomeView from '../views/HomeView.vue'
import PlatformCodeView from '../views/PlatformCodeView.vue'
import SingleTopKeywordsView from '../views/keywords/SingleTopKeywordsView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true, title: '首页' }
  },
  {
    path: '/platformcodeview',
    name: 'platformcodeview',
    component: PlatformCodeView,
    meta: { requiresAuth: true, title: '平台代码管理' }
  },
  {
    path: '/singletopkeyword',
    name: 'singletopkeyword',
    component: SingleTopKeywordsView,
    meta: { requiresAuth: true, title: 'Single Top Keyword' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: { requiresAuth: false, title: '关于我们' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false, title: '登录' }
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('@/views/Register.vue'),
  //   meta: { requiresAuth: false, title: '注册' }
  // },
  {
    path: '/import-tasks',
    name: 'ImportTaskList',
    component: () => import('@/views/import/ImportTaskList.vue'),
    meta: { requiresAuth: true, title: '导入任务' }
  },
  {
    path: '/topkeywords/overview',
    name: 'TopKeywordsOverview',
    component: () => import('@/views/keywords/TopKeywordsOverviewView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Top Keywords 概览'
    }
  },
  {
    path: '/topkeywords/topkeywordsdetails',
    name: 'TopKeywordsDetailedView',
    component: () => import('@/views/keywords/TopKeywordsDetailedView.vue'),
  },
    {
    path: '/keywords/keywordsmaster',
    name: 'KeywordsMasterView',
    component: () => import('@/views/keywords/KeywordsMasterView.vue'),
    meta: { requiresAuth: true, title: '主关键词管理' }
  },
  {
    path: '/keywords/mykeywords',
    name: 'KeywordsMain',
    component: () => import('@/views/keywords/MyKeywordsMainView.vue'),
    meta: { requiresAuth: true, title: '主关键词管理' }
  },
  {
    path: '/markets/markettools',
    name: 'MarketTools',
    component: () => import('@/views/markets/MarketTools.vue'),
    meta: { requiresAuth: true, title: '主关键词管理' }
  },
  // ==================== 阿里巴巴国际站相关路由 ====================
  {
  path: '/alibaba/status',
  name: 'AlibabaStatusView',
  component: () => import('@/views/alibaba/AlibabaStatusView.vue'),
  meta: { 
    requiresAuth: true, 
    title: '阿里巴巴国际站授权状态' 
  }
  },
  {
  path: '/keywords/neg-rules',
  name: 'NegKeywordRules',
  component: () => import('@/views/keywords/Hotkeywords/NegKeywordRulesView.vue'),
  meta: { title: '负面规则管理' }
  },
  // 负面反馈队列（待审核队列）
  {
    path: '/keywords/feedback-queue',
    name: 'NegKeywordFeedbackQueue',
    component: () => import('@/views/keywords/Hotkeywords/NegKeywordFeedbackQueueView.vue'),
    meta: { title: '负面反馈队列' }
  },
  {
  path: '/keywords/governance-review',
  name: 'KeywordGovernanceReview',
  component: () => import('@/views/keywords/Hotkeywords/KeywordGovernanceReviewView.vue'),
  meta: { 
    title: '数据审查与规则优化',
    icon: 'DataAnalysis'
  }
  },
  {
  path: '/keywords/alibaba-benchmark',
  name: 'AlibabaBenchmark',
  component: () => import('@/views/keywords/Hotkeywords/AlibabaBenchmarkView.vue'),
  meta: { title: '阿里大盘·机会雷达', requiresAuth: true }
  },
  {
  path: '/keywords/alibaba-benchmark-rule-debugger',
  name: 'AlibabaBenchmarkRuleDebugger',
  component: () => import('@/views/keywords/Hotkeywords/AlibabaBenchmarkRuleDebuggerView.vue'),
  meta: { title: '大盘规则调试器' }
  }
]

const whiteList = ['/login', '/about', '/register']

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ==================== 全局路由守卫 ====================
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // 如果本地有 token 但 Pinia 状态未同步，先初始化
  if (localStorage.getItem('access_token') && !authStore.isLoggedIn) {
    try {
      await authStore.initAuth()
    } catch (error) {
      console.warn('initAuth failed, clearing token', error)
      authStore.logout()
    }
  }

  // 需要登录但未登录 → 保存当前路径并跳转登录页
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    if (!whiteList.includes(to.path)) {
      localStorage.setItem('lastVisitedPath', to.fullPath)
    }
    next('/login')
    return
  }

  // 已登录用户访问登录页 → 智能跳转
  if (to.path === '/login' && authStore.isLoggedIn) {
    const lastPath = localStorage.getItem('lastVisitedPath') || '/'
    localStorage.removeItem('lastVisitedPath')
    const redirectPath = whiteList.includes(lastPath) || lastPath === '/login' ? '/' : lastPath
    next(redirectPath)
    return
  }

  next()
})

export default router